import React, { useEffect, useState } from 'react'
import Preloader from '../helpers/preloader'
import { useParams, Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from 'react-icons/io5'
import Preview from '../components/agent/complaints-preview'
import Navbar from '../components/agent/navbar';
import { useAtomValue } from 'jotai';
import { complaintData } from '../store';

const AgentPreview = () => {
  // States
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  const params = useParams()

  const complaints = useAtomValue(complaintData)

  const linkStyle = {
    textDecoration: 'none',
    color: '#aaa',
    display: 'flex',
    alignItems: 'center'
  }

  return (
    isLoading ? <Preloader /> : 
    <>
    <Navbar navText={'Home'} to={'/staff/home'}/>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20, padding: '20px 50px' }}>
        <Link to={'/staff/home/'} style={linkStyle}><IoArrowBackCircleOutline style={{ fontSize: 40 }} /></Link>
        <span>Complaint Preview</span>
      </div>
      <Preview complaint={complaints.filter(item => item._id.toString() === params.id)} />
    </>
  )
}

export default AgentPreview